function doCardProductOptions() {
  if (customElements.get("card-product-options")) return null;

  class CardProductOptions extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      if (this.form) {
        this.form.querySelector(`[name="id"]`).disabled = false;
      }
      this.productId = this.dataset.pid;
      this.productScript = this.firstElementChild;
      this.selects = this.querySelectorAll(".cardActionsOptionsWrapper select");
      this.addToCartBtn = this.querySelector(".cardActionsAdd-btn");
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      if (this.selects == null || this.productScript == null) return undefined;

      this.productData = JSON.parse(this.productScript.textContent.trim());
      if (this.productData == null) return undefined;

      this.init();
    }

    init() {
      this.selects.forEach((select) => {
        select.addEventListener("change", () => {
          if (this.getVariant() == null) {
            this.changeSubmitButtonDesign(this.addToCartBtn, "disable");
            return;
          }
          this.changeSubmitButtonDesign(this.addToCartBtn, "clear");
          this.changePrice(this.getVariant());
          this.updateCurrentVariant(this.getVariant());
        });
      });

      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.getVariant() == null) return null;
      this.changeSubmitButtonDesign(this.addToCartBtn, "loading");
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      const formData = new FormData(this.form);

      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");

          this.changeSubmitButtonDesign(this.addToCartBtn, "clear");
        });
    }

    /**
     * Takes the selected variant values and searches productData
     * It will return the variants data if it exist and it if variant.available is true
     * Otherwise this will return null
     * @returns {Object | null}
     */
    getVariant() {
      const { variants } = this.productData;
      const selectedValues = [];
      this.selects.forEach((select) => {
        selectedValues.push(select.value);
      });

      const selectedValuesString = selectedValues
        .map((selectedValue) => selectedValue)
        .join(" / ");

      const foundVariant = variants.filter(
        (item) => item.title === selectedValuesString
      );
      if (foundVariant.length > 0 && foundVariant[0].available) {
        return foundVariant[0];
      }

      return null;
    }

    changePrice(variant) {
      const productCard = this.closest(".product-card-wrapper");
      if (productCard == null) return null;

      const updatedPrice = `$${(variant.price / 100).toFixed(2)} ${
        Shopify.currency.active
      }`;
      productCard.querySelector(".price").style.display = "none";
      productCard.querySelector(".onChangePrice-price").innerHTML =
        updatedPrice;
      productCard
        .querySelector(".onChangePrice-wrapper")
        .setAttribute("data-status", 1);
    }

    updateCurrentVariant(variant) {
      this.setAttribute("data-current-variant-id", variant.id);
      this.form.querySelector("[name=id]").value = variant.id;
    }

    /**
     *
     * @param {HTMLElement} element
     * @param {String} action ['loading', 'soldout', 'disable', 'clear']
     * @returns
     */
    changeSubmitButtonDesign(element, action = "loading") {
      if (element == null) return null;

      if (action === "loading") {
        element.setAttribute("aria-disabled", true);
        element.classList.add("loading");
        element.setAttribute("data-status", "loading");
        element
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");
        return;
      }

      if (action === "soldout") {
        const soldOutMessage = element.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        element.setAttribute("aria-disabled", true);
        element.querySelector("span").classList.add("hidden");
        element.setAttribute("data-status", "soldout");
        soldOutMessage.classList.remove("hidden");
        return;
      }

      if (action === "disable") {
        element.setAttribute("data-status", "disable");
        return;
      }

      // clear
      element.setAttribute("data-status", "available");
      element.classList.remove("loading");
      if (!this.error) element.removeAttribute("aria-disabled");
      element
        .querySelector(".loading-overlay__spinner")
        .classList.add("hidden");
    }
  }

  customElements.define("card-product-options", CardProductOptions);
}
doCardProductOptions();
